import { Record } from 'immutable';

const InternalNoteRecord = Record({
  noteId: undefined,
  note: undefined,
  userId: undefined,
  userName: undefined,
});

class InternalNote extends InternalNoteRecord { }

InternalNoteRecord.create = (data) => new InternalNoteRecord(data);

export default InternalNote;



// WEBPACK FOOTER //
// ./data/InternalNotes/model.js